
  
const initState = {
    auditTrail: [],
    page: 1,
    limit: 10,
    count: 0
  };
  
  const AuditTrailReducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_AUDIT_TRAIL':
        return {
          ...state,
          auditTrail: action.payload.data,
          page: action.payload.page,
          limit: action.payload.limit,
          count: action.payload.count
        };
      case 'RESET_AUDIT_TRAIL':
        return {
          ...state,
          ...initState
        };
      default:
        return { ...state };
    }
  };
  
  export default AuditTrailReducer;
  